// extracted by mini-css-extract-plugin
export default {"loadingIconBox":"loadingIcon_loadingIconBox__L9W4z","loadindIconContent":"loadingIcon_loadindIconContent__O9xyF","loading":"loadingIcon_loading__lLKwq"};